import axios from 'axios';
import Api from './Api';

export const api = axios.create({
  baseURL: Api.request.URL,
});

// Hiwalay na client para sa token refresh.
// MAHALAGA: hindi ito pwedeng `api` -- kung 401 din ang isinagot ng /Auth/renew,
// mag-t-trigger ulit ito ng refresh, tapos ulit, tapos ulit (infinite loop).
const plain = axios.create({ baseURL: Api.request.URL });

function clearSession() {
  localStorage.removeItem('token');
  localStorage.removeItem('refreshTokens');
  localStorage.removeItem('auth_user');
}

function redirectToLogin() {
  clearSession();
  window.location.replace('/login');
}

/**
 * Isang refresh lang sa isang pagkakataon.
 *
 * Dati: kapag sabay-sabay na nag-401 ang limang request (karaniwan sa isang page
 * na maraming table), lima ring /Auth/renew ang pumuputok. Nag-uunahan sila, at
 * ang huling nakarating ang nag-o-overwrite -- minsan luma nang token.
 * Ngayon: iisang promise lang ang hinihintay ng lahat.
 */
let refreshPromise = null;

async function refreshAccessToken() {
  const refreshTokens = localStorage.getItem('refreshTokens');

  if (!refreshTokens) {
    redirectToLogin();
    // Dapat mag-throw, hindi mag-return. Dati, `return window.location.replace(...)`
    // ang ginagawa nito -- undefined ang naibabalik, kaya nase-save sa localStorage
    // ang literal na "undefined" bilang token bago pa man mag-redirect ang browser.
    throw new Error('Walang refresh token');
  }

  const { data } = await plain.post('/api/v2/Auth/renew', {
    userId: Api.request.userID,
    username: Api.request.username,
    refreshTokens,
  });

  return data.accessToken;
}

function getFreshToken() {
  if (!refreshPromise) {
    refreshPromise = refreshAccessToken().finally(() => {
      refreshPromise = null;
    });
  }
  return refreshPromise;
}

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  config.headers['X-User'] = Api.request.userID;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;

    // Walang `response` kapag network error, timeout, o CORS.
    // Dati, dito nag-cra-crash ang interceptor ("cannot read property 'status'
    // of undefined") at nawawala ang totoong error.
    if (!error.response) {
      return Promise.reject(error);
    }

    const { status, data } = error.response;

    if (status === 401 && originalRequest && !originalRequest._retry) {
      originalRequest._retry = true;
      try {
        const token = await getFreshToken();
        localStorage.setItem('token', token);
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return api(originalRequest);
      } catch (err) {
        redirectToLogin();
        return Promise.reject(err);
      }
    }

    if (status === 403) {
      redirectToLogin();
      return Promise.reject(error);
    }

    if (data && data.message === 'invalid refresh token') {
      redirectToLogin();
      return Promise.reject(error);
    }

    return Promise.reject(error);
  }
);

export default api;